module.exports = __webpack_public_path__ + "static/media/chefs.99ab868e.svg";